import { buildTagColorByName, resolveTagColor } from '@/features/shared/tags';
import { useTagOptions } from '@/shared/hooks';
import { Inline } from '@/ui';
import { tableCellTagChipSx } from '@/ui/composites/table/cells/sharedCellContent';
import { Chip, Text } from '@/ui/primitives';
import type { ReactElement } from 'react';

type DetailTagsValueProps = {
  tags: string[] | undefined;
  projectId?: string | null;
  emptyLabel?: string;
};

export const DetailTagsValue = ({
  tags,
  projectId,
  emptyLabel = '-',
}: DetailTagsValueProps): ReactElement => {
  const resolvedTags = tags?.filter((tag) => tag.trim().length > 0) ?? [];
  const { tagOptions } = useTagOptions({
    projectId,
    enabled: resolvedTags.length > 0,
  });
  const tagColorByName = buildTagColorByName(tagOptions);

  if (resolvedTags.length === 0) {
    return (
      <Text role="body" component="span">
        {emptyLabel}
      </Text>
    );
  }

  return (
    <Inline gap="sm" wrap="wrap" align="center" sx={{ width: '100%', minWidth: 0 }}>
      {resolvedTags.map((tag, index) => (
        <Chip
          key={`${tag}-${String(index)}`}
          size="xs"
          tone={resolveTagColor(tag, tagColorByName)}
          label={tag}
          sx={tableCellTagChipSx}
        />
      ))}
    </Inline>
  );
};
